import axios from 'axios'
import { buildRequestMutexKey, runWithRequestMutex } from './requestMutex'


function createError(data, status, popupOnError) {
    let err_msg = "תקלת שרת, אנא נסה שנית מאוחר יותר";
    if (data.err?.content) {
        err_msg = data.err?.content;
    }
    if (data.message) {
        err_msg = data.message
    }
    return {
        error: {
            popupOnError,
            status: status,
            data: err_msg,
        },
    }
}

const extendParams = (config) => {
    if( window.location.search) {
        const params = new URLSearchParams(window.location.search)
        config.params = {...Object.fromEntries(params.entries()), ...(config?.params || {})}
    }

    return config
}

const client = axios.create({
    baseURL: '//' + window.apiUrl,
    withCredentials: true,
    headers: {
        'x-xsrf-token': 1
    }
})

const cdn = axios.create({
    baseURL: '//' + window.cdnUrl,
    withCredentials: true,
    headers: {
        'x-xsrf-token': 1
    }
})

client.interceptors.request.use(extendParams)
cdn.interceptors.request.use(extendParams)


const shouldUseCdn = (method, url) => {
    return method === 'GET' &&
        window?.cdnUrl &&
        window?.GetMethods?.patterns?.some(p => new RegExp(p).test(url));
}
export const axiosBaseQuery = ({baseUrl = ''}) => {

    return async (options) => {
        let {url, method, data, params, headers, popupOnError=true, responseType} = options;
        method = method ? method.toUpperCase() : 'GET';

        if (!url.startsWith('http')) {
            url = (baseUrl + url).replaceAll('//', '/')
        }

        const mutexKey = buildRequestMutexKey(method, url);

        return runWithRequestMutex(mutexKey, async (releaseMutex) => {
            try {
                let agent = client;

                if (shouldUseCdn(method, url)) {
                    agent = cdn
                }

                const response = await agent.request({
                    url,
                    method,
                    data,
                    params,
                    headers,
                    responseType,
                })

                releaseMutex();

                if (responseType === 'blob') {
                    return {
                        data: response.data,
                        error: null,
                    }
                }

                if (!response.data.statusCode && !response.data.status) {
                    return createError(response.data, response.status, popupOnError)
                }

                if (response.data.err) {
                    return {
                        data: response.data.data,
                        error: {
                            ...response.data.err,
                            popupOnError: popupOnError,
                        },
                    }
                }

                return {
                    data: response.data.data,
                    error: response.data.err,
                }
            } catch (e) {
                releaseMutex();
                console.error(e)
                const status = e.response?.status
                let errPayload = e.response?.data
                if (typeof Blob !== 'undefined' && errPayload instanceof Blob) {
                    try {
                        errPayload = JSON.parse(await errPayload.text())
                    } catch (_) {
                        errPayload = {}
                    }
                }
                return createError(errPayload || {}, status, popupOnError)
            }
        });
    }
}



